import axios from 'axios'

export const ax = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
})
